import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function GuideDebutantComplet() {
  return <SEOArticlePage article={articleContents["guide-debutant-complet"]} />;
}